export default {"src":"/_next/static/media/ns_logo_full_white.e5e9c91a.svg","height":80,"width":300,"blurWidth":0,"blurHeight":0};